module.exports = __webpack_public_path__ + "src/assets/games/27/11.jpg";